<template>
  <el-select
    v-model="currentValue"
    :multiple="multi"
    :remote-method="fetchData"
    filterable
    remote
    reserve-keyword
    clearable
    automatic-dropdown
    placeholder="选择或搜索题库"
    class="filter-item"
    @change="handlerChange"
  >
    <el-option
      v-for="item in allDataList"
      :key="item.id"
      :label="item.title"
      :value="item.id"
    />
  </el-select>
</template>

<script>
import { fetchPaging } from '@/api/repo'
// Simple shared cache to avoid duplicate requests across multiple RepoSelect instances
let repoListCache = null
let repoListPromise = null

export default {
  name: 'RepoSelect',
  props: {
    multi: {
      type: Boolean,
      default: false
    },
    // eslint-disable-next-line vue/require-default-prop
    value: {
      type: [String, Array, Number],
      default: null
    },
    // eslint-disable-next-line vue/require-default-prop
    excludes: Array
  },
  data() {
    return {
      // 下拉选项值
      dataList: [],
      // 默认科目选项
      defaultSubjects: [
        { id: 'math', title: '数学' },
        { id: 'chinese', title: '语文' },
        { id: 'english', title: '英语' },
        { id: 'physics', title: '物理' },
        { id: 'chemistry', title: '化学' },
        { id: 'biology', title: '生物' },
        { id: 'history', title: '历史' },
        { id: 'geography', title: '地理' },
        { id: 'politics', title: '政治' },
        { id: 'computer', title: '计算机' },
        { id: 'art', title: '美术' },
        { id: 'music', title: '音乐' },
        { id: 'pe', title: '体育' }
      ],
      currentValue: []
    }
  },

  computed: {
    // 合并API数据和默认选项
    allDataList() {
      return this.dataList.length > 0 ? this.dataList : this.defaultSubjects
    }
  },

  watch: {
    // 检测查询变化
    value: {
      handler() {
        this.currentValue = this.value
      }
    }
  },
  created() {
    this.currentValue = this.value
    this.fetchData()
  },
  methods: {

    async fetchData(q) {
      // Reuse cache if available
      if (Array.isArray(repoListCache)) {
        this.dataList = repoListCache
        return
      }
      // If a request is in-flight, await it
      if (repoListPromise) {
        try {
          const list = await repoListPromise
          this.dataList = Array.isArray(list) ? list : []
        } catch (e) {
          this.dataList = []
        }
        return
      }
      // Start a new request and cache the promise
      repoListPromise = fetchPaging({ pageNum: 1, pageSize: 1000 })
        .then((res) => {
          repoListCache = res && res.data ? res.data : []
          return repoListCache
        })
        .catch(() => {
          // 如果API调用失败，回退为空数组（仍允许使用默认学科列表）
          repoListCache = []
          return repoListCache
        })
        .finally(() => {
          // Keep cache, clear the pending marker so next call can use cache directly
          repoListPromise = null
        })
      try {
        const list = await repoListPromise
        this.dataList = Array.isArray(list) ? list : []
      } catch (e) {
        this.dataList = []
      }
    },
    handlerChange(e) {
      const obj = this.allDataList.find((item) => {
        return item.id === e
      })

      this.$emit('change', obj)
      this.$emit('input', e)
    }
  }
}
</script>
